import { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios'
import { getCookie } from '~utils/cockie'

export const handleRequestFulfilled = (config: AxiosRequestConfig) => {
  const accessToken = getCookie('_TOKEN_BFF')

  if (accessToken) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${accessToken}`,
    }
  }

  return config
}

export const handleRequestRejected = (error: AxiosError) => {
  return Promise.reject(error)
}

export const handleResponseFulfilled = (success: AxiosResponse) => {
  return success
}

export const handleResponseRejected = (error: AxiosError) => {
  if (error.response === undefined) {
    return Promise.reject(new Error('Não foi possível conectar ao servidor.'))
  }

  if (error.response.status === 401) {
    if (process.env.NODE_ENV !== "development") window.location.assign(process.env.FRETEBRAS_LOGOUT_URL)
    return Promise.resolve()
  }

  return Promise.reject(error)
}
